import React, { Component, PropTypes } from 'react';
import { Deck } from 'spectacle-ppa';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './index.md';

import start from './sections/01_start/startSection';
import song from './sections/03_song/songSection';
import missionReport from
  './sections/11_missionReport/missionReportSection';
import esOpeningStory from './sections/12_esOpeningStory/esOpeningStorySection';
import gameShow from './sections/20_gameShow/gameShowSection';
import mme from './sections/13_mme/mmeSection';
import classActivity from './sections/30_classActivity/classActivitySection';
import esClosingStory from './sections/60_esClosingStory/esClosingStorySection';
import missionAssignment from
  './sections/70_missionAssignment/missionAssignmentSection';
import finish from './sections/90_finish/finishSection';

const md = new MarkdownScript(markdownFile);
const level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
const title = md.getSectionMetadata(`Level ${level}`, 'Title');

export default class extends Component {

  static contextTypes = {
    regionData: PropTypes.object.isRequired
  };

  static metadata = {
    title
  };

  render() {
    const { regionData } = this.context;
    return (
      <Deck transition={['slide']}
            transitionDuration={800}
            progress="bar">

        {/* Start */}
        {start({ level, title, regionData })}

        {/* Theme Song */}
        {song({ level, regionData })}

        {/* Mission Report */}
        {missionReport({ level, regionData })}

        {/* One-off popcorn activity instructions */}
        {classActivity({ level, subActivity: 'a', regionData })}

        {/* Esmeralda Opening Story */}
        {esOpeningStory({ level, regionData })}

        {/* Game Show */}
        {gameShow({ level, regionData })}

        {/* Messages from Mother Earth */}
        {mme({ level, regionData })}

        {/* Class Activity: Waste Math */}
        {classActivity({ level, subActivity: 'b', regionData })}

        {/* Class Activity: Eat Me First Box */}
        {classActivity({ level, subActivity: 'c', regionData })}

        {/* Esmeralda Closing Story */}
        {esClosingStory({ level, regionData })}

        {/* Mission Assignment */}
        {missionAssignment({ level, title, regionData })}

        {/* Finish */}
        {finish({ level, regionData })}

      </Deck>
    );
  }

}



// WEBPACK FOOTER //
// ./programs/zeroHeroes/level2.jsx